import statusbarSchema from './statusbar-schema.graphql';

export { statusbarSchema };


